/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Sorting of the application branding object
 */
export enum sortingAppBrandingObjectEnum {
    NAME = 'NAME',
    BUSINESS_UNIT = 'BUSINESS_UNIT',
    TT_BASE_URL = 'TT_BASE_URL',
    MSC_BASE_URL = 'MSC_BASE_URL',
    XBU_CATEGORY = 'XBU_CATEGORY',
}